/** ObjectVid значения см. Sport24.WebApi.Enums.ObjectVid */
export const TAG_OBJECT_VID_CLIENTS = 1;
export const TAG_OBJECT_VID_DIALOGS = 22;

export const tagObjectVidOptions = [
  { value: TAG_OBJECT_VID_CLIENTS, label: "Клиенты" },
  { value: TAG_OBJECT_VID_DIALOGS, label: "Диалоги" },
];

export const tagObjectVidLabels = Object.fromEntries(tagObjectVidOptions.map((o) => [o.value, o.label]));
